import React from 'react';
import { Breadcrumb, Col, Row } from 'antd';
import { NavLink, useLocation } from 'react-router-dom';

const capitalizeChar = (str: string) => {
    return str.toUpperCase();
    // + str.slice(1);
};

/**
 * This component uses react-router-dom
 * (should be used inside a Provider)
 */
const BreadCrumbs = () => {
    const location = useLocation();
    const pathSnippets = location.pathname.split('/').filter((i) => i);
    // Exclua o último elemento do array pathSnippets
    const breadcrumbItems = pathSnippets.slice(0, -1).map((snippet, index) => {
        const url = `/${pathSnippets.slice(0, index + 1).join('/')}`;
        const title = snippet.replace(/-/g, ' ');
        return (
            <Breadcrumb.Item key={url}>
                <NavLink to={url}>{capitalizeChar(title)}</NavLink>
            </Breadcrumb.Item>
        );
    });

    return (
        <div className='bread-crumb-altered'>
            <Row>
                <Col className="flex items-center gap-2 p-4">
                    <Breadcrumb separator={">"}>
                        <Breadcrumb.Item>
                            <NavLink to="/">INÍCIO</NavLink>
                        </Breadcrumb.Item>
                        {breadcrumbItems}
                    </Breadcrumb>
                </Col>
            </Row>
        </div>
    );
};


export { BreadCrumbs };